/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import { styled, css, useTheme } from '@mui/material/styles';
import { Stack, Typography, useMediaQuery, Box } from '@mui/material';
import { MAP_PHARMARCIES_URL } from '@/src/constants';

const CardsWrapper = styled(Box)(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    margin-top: ${theme.spacing(5)};

    ${theme.breakpoints.up('sm')} {
      flex-direction: row;

      > div:first-child {
        margin-right: ${theme.spacing(8)};
      }
    }

    > div {
      flex: 1 1 40%;
      margin-bottom: ${theme.spacing(4)};
    }

    iframe {
      height: 100%;
      min-height: 520px;
    }
  `,
);

const TlcPharamcySection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box className="blue-links">
      <Typography
        variant={isMobile ? 'h3' : 'h2'}
        color="primary"
        component="h2"
        textAlign={{ sm: 'center' }}
        mt={4}
      >
        La téléconsultation en pharmacie
      </Typography>

      <CardsWrapper>
        <Box>
          <iframe title="pharmacies-map" src={MAP_PHARMARCIES_URL} />
        </Box>

        <Box>
          <Typography>
            Les pharmacies ont un rôle central dans le parcours de soin des
            patients. Les pharmaciens délivrent des médicaments peuvent donner
            des conseils médicaux et sont disponibles pour vous accompagner afin
            d’effectuer une téléconsultation dans leur pharmacie.
            <Typography variant="h5" component="h3" mt={3}>
              Les avantages :{' '}
            </Typography>
            <Stack
              spacing={1}
              component="ul"
              sx={{
                margin: ({ spacing }) => spacing(4, 0, 4, 3),
                '> li': { listStyle: 'disc', listStylePosition: 'outsidee' },
              }}
            >
              <li>
                Gain de temps :{' '}
                <a
                  href="/teleconsultation/article/pourquoi-faire-une-teleconsultation/la-teleconsultation-en-pharmacie-comment-ca-fonctionne"
                  target="_blank"
                  rel="noopener"
                >
                  la téléconsultation en pharmacie
                </a>{' '}
                permet d’obtenir le diagnostic d’un médecin, une ordonnance et
                les médicaments au même endroit.
              </li>
              <li>
                Accessibilité à la consultation en ligne : le pharmacien peut
                vous aider à créer votre compte sur la plateforme et à vous
                accompagnez tout au long du processus. Si vous ne disposez pas
                de mail ou de carte bancaire, la pharmacie est autorisée à vous
                avancez les frais de consultation.
              </li>
            </Stack>
            Une téléconsultation en pharmacie est remboursée de la même manière
            qu’une consultation classique et vous obtenez vos documents médicaux
            directement en ligne via la plateforme de téléconsultation. Votre
            pharmacien reçoit en même temps que vous l’ordonnance. Vous n’avez
            plus qu’à récupérer vos médicaments.
          </Typography>

          <Box mt={4}>
            <Typography variant={isMobile ? 'h6' : 'h5'} component="h4">
              Pour aller plus loin
            </Typography>

            <Stack spacing={1}>
              <a
                href="/teleconsultation/article/pourquoi-faire-une-teleconsultation/la-teleconsultation-en-cas-d-urgence-est-ce-une-bonne-pratique"
                target="_blank"
                rel="noopener"
              >
                La téléconsultation en cas d’urgence : est-ce une bonne pratique
                ?
              </a>

              <a
                href="/teleconsultation/article/pourquoi-faire-une-teleconsultation/teleconsultation-infirmiere"
                target="_blank"
                rel="noopener"
              >
                La téléconsultation assistée avec une infirmière
              </a>
            </Stack>
          </Box>
        </Box>
      </CardsWrapper>
    </Box>
  );
};

export default TlcPharamcySection;
